// extracted by mini-css-extract-plugin
module.exports = {"image":"blockquote_image__jMeB5"};